import React, { useState, useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles' 
import CardActionArea from '@material-ui/core/CardActionArea'
import { connect } from "react-redux"
import CardContent from '@material-ui/core/CardContent'
import Input from '@material-ui/core/Input'
import TopBarNav from '../common/TopBarNav'
import { useHistory } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import DataTable from 'react-data-table-component'
import { MaintenanceStylesInvoice } from './MaintenanceStyles'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import DeleteIcon from "@material-ui/icons/Delete"
import IconButton from '@material-ui/core/IconButton'
import 'react-toastify/dist/ReactToastify.css'
import * as maintenanceActions from '../../actions/maintenance/MaintenanceActions'
import { bindActionCreators } from 'redux'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as navigationActions from '../../actions/common/NavigationActions'
import { getInvoiceHitoricalTableColumns, getRejectedInvoiceTableColumns } from '../common/Utils'
import { Backdrop, CircularProgress } from '@material-ui/core'

const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }

const MaintenanceUploadInvoice = ({ classes, ...props }) => {
    const history = useHistory()
    const [fileXML, setFileXml] = useState()
    const [fileXMLMarkup, setFileXmlMarkup] = useState()
    const [filePDF, setFilePdf] = useState()
    const [filePDFMarkup, setFilePdfMarkup] = useState()
    const { match: { params } } = props
    const [statusGridInvoice, setStatusGridInvoice] = useState(false)
    const [statusGridMarkup, setStatusGridMarkup] = useState(true)
    const [statusGridHistory, setStatusGridHistory] = useState(true)
    const [nameXML, setNameXML] = useState('')
    const [nameXMLMarkup, setNameXMLMarkup] = useState('')
    const [namePDF, setNamePDF] = useState('')
    const [namePDFMarkup, setNamePDFMarkup] = useState('')
    const [statusNameXmlHidden, setStatusNameXmlHidden] = useState(true)
    const [statusNameXmlHiddenMarkup, setStatusNameXmlHiddenMarkup] = useState(true)
    const [statusNamePdfHidden, setStatusNamePdfHidden] = useState(true)
    const [statusNamePdfHiddenMarkup, setStatusNamePdfHiddenMarkup] = useState(true)
    const [textInvoice, setTextInvoice] = useState(classes.TextSelected)
    const [textMarkup, setTextMarkup] = useState(classes.Text)
    const [textHistory, setTextHistory] = useState(classes.Text)
    const [disabledButton, setDisabledButton] = useState(false)
    const [disabledMarkupButton, setDisabledMarkupButton] = useState(false)
    const [hiddenStatus, setHiddenStatus] = useState(true)
    const [hiddenMarkupStatus, setHiddenMarkupStatus] = useState(true)
    const [hiddenNoDataStatus, setHiddenNoDataStatus] = useState(true)

    const [buttonInvoice, setButtonbuttonInvoice] = useState(classes.GridBorderSelected)
    const [buttonMarkup, setButtonbuttonMarkup] = useState(classes.GridBorder)
    const [buttonHistory, setButtonbuttonHistory] = useState(classes.GridBorder)
    const [statusGridRejectedInvoice, setStatusGridRejectedInvoice] = useState(true)
    const [openBackdrop, setOpenBackdrop] = useState(false)
    const [isSupplierMarkup, setIsSupplierMarkup] = useState(false)
    const [markupSchemaAccepted, setMarkupSchemaAccepted] = useState(false)
    const [awatingMarkup, setAwatingMarkup] = useState(false)
    const [markupLoaded, setMarkupLoaded] = useState(false)    
    const [isMarkupZero, setMarkupZero] = useState(false)

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/maintenance/UploadInvoice',
            linkLegend: 'Subir factura',
            urlParams: [{ key: 'orderId', value: params.orderId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Order_Detail(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        props.actions.fetch_Rejected_Invoice(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        handleOpenBackdrop()
        if(props.orderDetail.supplierMarkup!==undefined && props.orderDetail.supplierMarkup!==null)
        {
            if(props.orderDetail.supplierMarkup.markupPercentageVal>=0)
            {
                if(props.orderDetail.supplierMarkup.markupPercentageVal>0)
                {
                    setMarkupZero(false);
                    setIsSupplierMarkup(true);
                }
                else
                {
                    setMarkupZero(true);
                    setIsSupplierMarkup(false);
                 }
                if(props.orderDetail.markupInvoice!==undefined && props.orderDetail.markupInvoice!==null){
                    setHiddenNoDataStatus(true);
                    setMarkupSchemaAccepted(true);
                    setHiddenMarkupStatus(false);
                    setHiddenStatus(true);
                    setAwatingMarkup(true);
                    setNameXML('Factura '+ params.orderId +' en formato XML cargada');
                    setNamePDF('Factura '+ params.orderId +' en formato PDF cargada');
                    if(props.orderDetail.markupInvoice.uuid.length >= 18)
                    {
                        setMarkupLoaded(true);
                        setHiddenStatus(false);
                        setHiddenMarkupStatus(true);
                        setNameXMLMarkup('Comisión '+ params.orderId +' en formato XML cargada');
                        setNamePDFMarkup('Comisión '+ params.orderId +' en formato PDF cargada');
                    }
                }
                else{
                    setHiddenNoDataStatus(false);
                    setMarkupSchemaAccepted(false);
                }
            }
            else
            {
                setIsSupplierMarkup(false);
            }
        }
        handleCloseBackdrop()
    }, [props.orderDetail]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.listRejectedInvoices.length === 0) {
            setDisabledButton(false)
            setDisabledMarkupButton(false)
            setStatusGridRejectedInvoice(true)
        } else {
            setDisabledButton(true)
            setDisabledMarkupButton(true)
            setStatusGridRejectedInvoice(false)
        }
    }, [props.listRejectedInvoices]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccessFetch = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const ChangeOption = (e) => {
        switch (e) {
            case 'Invoice':
                setButtonbuttonInvoice(classes.GridBorderSelected)
                setButtonbuttonMarkup(classes.GridBorder)
                setButtonbuttonHistory(classes.GridBorder)
                setTextInvoice(classes.TextSelected)
                setTextMarkup(classes.Text)
                setTextHistory(classes.Text)
                setStatusGridInvoice(false)
                setStatusGridMarkup(true)
                setStatusGridHistory(true)
                props.listRejectedInvoices.length === 0 ? setStatusGridRejectedInvoice(true) : setStatusGridRejectedInvoice(false)
                break;
            case 'Markup':
                setButtonbuttonInvoice(classes.GridBorder)
                setButtonbuttonMarkup(classes.GridBorderSelected)
                setButtonbuttonHistory(classes.GridBorder)
                setTextInvoice(classes.Text)
                setTextMarkup(classes.TextSelected)
                setTextHistory(classes.Text)
                setStatusGridInvoice(true)
                setStatusGridMarkup(false)
                setStatusGridHistory(true)
                props.listRejectedInvoices.length === 0 ? setStatusGridRejectedInvoice(true) : setStatusGridRejectedInvoice(false)
                break;  
            case 'History':
                handleOpenBackdrop()
                props.actions.fetch_Invoice_History(props.userLanguage, props.userToken, props.orderDetail.id, onError, onSuccessFetch)
                setButtonbuttonInvoice(classes.GridBorder)
                setButtonbuttonMarkup(classes.GridBorder)
                setButtonbuttonHistory(classes.GridBorderSelected)
                setTextInvoice(classes.Text)
                setTextMarkup(classes.Text) 

                setTextHistory(classes.TextSelected)
                setStatusGridInvoice(true) 
                setStatusGridMarkup(true)
                setStatusGridHistory(false)
                setStatusGridRejectedInvoice(true)
                break;
            default:
                break;
        }
    }

    const onChangeHandlerXML = event => {
        if (checkFileTypeXML(event)) {
            setFileXml(event.target.files[0])
            setStatusNameXmlHidden(false)
            setNameXML(event.target.files[0].name)
        } else {
            setStatusNameXmlHidden(true)
            setNameXML('')
            setFileXml(null)
        }
    }

    const onChangeHandlerXMLMarkup = event => {
        if (checkFileTypeXML(event)) {
            setFileXmlMarkup(event.target.files[0])
            setStatusNameXmlHiddenMarkup(false)
            setNameXMLMarkup(event.target.files[0].name)
        } else {
            setStatusNameXmlHiddenMarkup(true)
            setNameXMLMarkup('')
            setFileXmlMarkup(null)
        }
    }

    const onChangeHandlerPDF = event => {
        if (checkFileTypePDF(event)) {
            setFilePdf(event.target.files[0])
            setStatusNamePdfHidden(false)
            setNamePDF(event.target.files[0].name)
        } else {
            setStatusNamePdfHidden(true)
            setNamePDF('')
            setFilePdf(null)
        }
    }

    const onChangeHandlerPDFMarkup = event => {
        if (checkFileTypePDF(event)) {
            setFilePdfMarkup(event.target.files[0])
            setStatusNamePdfHiddenMarkup(false)
            setNamePDFMarkup(event.target.files[0].name)
        } else {
            setStatusNamePdfHiddenMarkup(true)
            setNamePDF('')
            setFilePdfMarkup(null)
        }
    }

    const checkFileTypeXML = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/xml']

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                return true
            }
        }
    }

    const checkFileTypePDF = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf']

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                return true
            }
        }
    }

    const SendFile = () => {
        if (fileXML != null && filePDF != null) {
            handleOpenBackdrop()
            const formData = new FormData();
            formData.append('files', fileXML);
            formData.append('files', filePDF);
            props.actions.Update_Invoice(props.userLanguage, props.userToken, params.orderId, formData, onError, onSuccess)

            setDisabledButton(true)
            awatingMarkup ? setHiddenMarkupStatus(false) : setHiddenStatus(false)
        } else {
            toast.info("Debes de seleccionar los archivos XML y PDF para poder guardar.")
        }
    }

    const SendMarkupFile = () => {
        if (fileXMLMarkup != null && filePDFMarkup != null) {
            handleOpenBackdrop()
            const formData = new FormData();
            formData.append('files', fileXMLMarkup);
            formData.append('files', filePDFMarkup);
            props.actions.Update_Markup_Invoice(props.userLanguage, props.userToken, params.orderId, formData, onError, onMarkupSuccess);

            setDisabledMarkupButton(true);
            setHiddenMarkupStatus(true);
            setHiddenStatus(false);
        } else {
            toast.info("Debes de seleccionar los archivos XML y PDF de comisión para poder guardar.")
        }
    }

    const onSuccess = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            toast.success('Se agregó correctamente la factura', { className: classes.toastSuccess })
            if (response.partial === true) {
                isSupplierMarkup ? setDisabledButton(true) : setDisabledButton(false)
                setHiddenStatus(true)
            } else {
                setDisabledButton(true)
                setHiddenStatus(false)
            }
            
            if(isSupplierMarkup)
                props.actions.fetch_Order_Detail(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)

            ClearXML()
            ClearPDF()
        }
        else {
            toast.error('Ocurrió un error al validar la factura', { className: classes.toastError })
            setDisabledButton(false)
            setHiddenStatus(true)
        }
    }

    const onMarkupSuccess = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            toast.success('Se agregó correctamente la comisión', { className: classes.toastSuccess })
            if (response.partial === true) {
                setDisabledMarkupButton(true)
                setHiddenMarkupStatus(true)
                setHiddenStatus(false)
            } else {
                setDisabledMarkupButton(true)
                setHiddenMarkupStatus(true)
                setHiddenStatus(false)
            }
            props.actions.fetch_Order_Detail(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
            ClearMarkupXML()
            ClearMarkupPDF()
        }
        else {
            toast.error('Ocurrió un error al validar la comisión', { className: classes.toastError })
            setDisabledMarkupButton(false)
            setHiddenMarkupStatus(false)
            setHiddenStatus(true)
        }
    }
    
    const ClearXML = () => {
        if(!awatingMarkup)
        {
            Array.from(document.querySelectorAll('div.fileXML > input')).forEach(
                input => (input.value = "")
            )

            setStatusNameXmlHidden(true)
            setNameXML('')
            setFileXml(null)
        }
    }

    const ClearMarkupXML = () => {
        Array.from(document.querySelectorAll('div.fileXMLMarkup > input')).forEach(
            input => (input.value = "")
        )

        setStatusNameXmlHiddenMarkup(true)
        setNameXMLMarkup('')
        setFileXmlMarkup(null)
    }

    const ClearPDF = () => {
        if(!awatingMarkup)
        {
            Array.from(document.querySelectorAll('div.filePDF > input')).forEach(
                input => (input.value = "")
            )

            setStatusNamePdfHidden(true)
            setNamePDF('')
            setFilePdf(null)
        }
    }

    const ClearMarkupPDF = () => {
        Array.from(document.querySelectorAll('div.filePDFMarkup > input')).forEach(
                input => (input.value = "")
            )

            setStatusNamePdfHiddenMarkup(true)
            setNamePDFMarkup('')
            setFilePdfMarkup(null)
        }

    const DeleteRejectedInvoice = (invocieId) => {
        handleOpenBackdrop()
        props.actions.delete_Rejected_Invoice(props.userLanguage, props.userToken, invocieId, onSuccessDelete, onError)
    }

    const onSuccessDelete = () => {
        handleCloseBackdrop()
        toast.success('Factura eliminada', { className: classes.toastSuccess })
        props.actions.fetch_Rejected_Invoice(props.userLanguage, props.userToken, params.orderId, onError)
    }

    return (
        <div>
            <TopBarNav />
            <br />

            <Container maxWidth="lg" >
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container>
                    <Grid item xs={4} style={{ marginLeft: '-25px' }}>
                        <BreadcrumbsHistory />
                    </Grid>
                    <Grid item xs={8}>
                        <h5>Detalles de la orden de trabajo Subir factura</h5>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="lg" className={classes.root}>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h6>Autorización: {params.orderId}</h6>
                        <h6>VIN: {props.orderDetail.vin ? props.orderDetail.vin : "Sin información"}</h6>
                        {isSupplierMarkup || isMarkupZero ?
                            <h6>Markup Autorizado: {(props.orderDetail.supplierMarkup.markupPercentageVal * 100).toFixed(0)}%</h6> : <> </>
                        }
                        <h6 hidden={hiddenStatus}>Estatus de factura: En revisión de pago</h6>
                        <h6 hidden={hiddenMarkupStatus}>Estatus de factura: En espera de Comisión</h6>
                        <h6 hidden={hiddenNoDataStatus}>Estatus de factura: Sin factura</h6>
                        <br />
                    </Grid>
                </Grid>

                <Grid container item xs={11} className={classes.ContainerBorder} >
                    <Grid item xs={3} className={classes.ContainerOptionBorder} >
                        <CardActionArea className={buttonInvoice} onClick={(e) => ChangeOption("Invoice")} style={{ marginBottom: '5px' }}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textInvoice}>Subir Factura</h5>
                            </CardContent>
                        </CardActionArea>

        {isSupplierMarkup ? 
                        <CardActionArea 
                            className={buttonMarkup} 
                            onClick={(e) => ChangeOption("Markup")} 
                            style={{marginBottom: '5px' }} 
                            disabled={!markupSchemaAccepted}>
                            <CardContent 
                                className={classes.dashboardAlign}>
                                    {
                                        markupSchemaAccepted ? 
                                        <h5 className={textMarkup}>Subir Comisión</h5>
                                        :
                                        <h5 className={textMarkup} style={{ color: "gray" }}>Subir Comisión</h5>
                                    }
                            </CardContent>
                        </CardActionArea> : <> </>
        }
                    
                        <CardActionArea className={buttonHistory} onClick={(e) => ChangeOption("History")}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textHistory}>Historial de errores</h5>
                            </CardContent>
                        </CardActionArea>

                    </Grid>
                    <Grid item xs={9} >
                        <Container maxWidth="lg" >
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <br />
                                    <br />
                                    <Grid container item xs={12}>
                                        <Grid item xs={8}>
                                            <div className="form-group files">
                                                <label>Subir XML &nbsp;&nbsp;</label>
                                                <Input type="file" name="file" disabled={awatingMarkup ? true : disabledButton} className="fileXML" onChange={onChangeHandlerXML} />
                                            </div>
                                        </Grid>
                                        <br />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12} hidden={markupSchemaAccepted ? false : statusNameXmlHidden}>
                                        <Grid item xs={7} style={{ textAlign: 'right', paddingTop: '15px', paddingright: '10px' }}>
                                            <label>{nameXML}</label>
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <IconButton aria-label="delete" className={classes.ButtonDelete} disabled={awatingMarkup ? true : disabledButton} onClick={ClearXML}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <br />
                                    <Grid container item xs={12}>
                                        <Grid item xs={8}>
                                            <div className="form-group files">
                                                <label>Subir PDF &nbsp;&nbsp;</label>
                                                <Input type="file" name="file" disabled={awatingMarkup ? true : disabledButton} className="filePDF" onChange={onChangeHandlerPDF} />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12} hidden={markupSchemaAccepted ? false : statusNamePdfHidden}>
                                        <Grid item xs={7} style={{ textAlign: 'right', paddingTop: '15px', paddingright: '10px' }}>
                                            <label>{namePDF}</label>
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <IconButton aria-label="delete" className={classes.ButtonDelete} disabled={awatingMarkup ? true : disabledButton} onClick={ClearPDF}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} hidden={statusGridInvoice} style={{ textAlign: 'center', paddingTop: '10px' }}>
                                <Grid container item xs={12}>
                                    <Grid item xs={8}></Grid>
                                    <Grid item xs={4}>
                                        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                                            <Button type="button" className={classes.ButtonSave} variant="outlined" disabled={awatingMarkup ? true : disabledButton} onClick={SendFile}>Guardar</Button>
                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {
                                props.listRejectedInvoices && (
                                    <Grid item xs={12} hidden={statusGridRejectedInvoice} style={{ paddingTop: '15px' }}>
                                        <DataTable
                                            columns={getRejectedInvoiceTableColumns('Maintenance', { DeleteRejectedInvoice })}
                                            data={props.listRejectedInvoices}
                                            defaultSortField=""
                                            noHeader={true}
                                            dense
                                            highlightOnHover
                                            pointerOnHover
                                        />
                                    </Grid>
                                )
                            }

                        <Grid container item xs={12} hidden={statusGridMarkup}>
                          <Grid item xs={12} className={classes.dashboardAlign}>
                            <br />
                            <br />
                            <Grid container item xs={12}>
                               <Grid item xs={8}>
                                <div className="form-group files" style={{textAlign: 'left'}}>
                                   {markupSchemaAccepted ?
                                    <strong style={{marginLeft: '60px'}}>Monto Esperado: $<strong>{props.orderDetail.markupInvoice.subtotal.toFixed(2)}</strong></strong>
                                    : 
                                    <strong style={{marginLeft: '30px'}}>Monto Esperado: Esperando Factura de Mantenimiento</strong>
                                    }
                                    <br/><br/>
                                   <label style={{marginLeft: '60px'}}>Subir XML de Comisión&nbsp;&nbsp;</label>
                                   <Input type="file" name="file" disabled={markupLoaded ? true : disabledMarkupButton} className="fileXMLMarkup" onChange={onChangeHandlerXMLMarkup} />
                                </div>
                               </Grid>
                               <br />
                            </Grid>
                            </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridMarkup}>
                            <Grid item xs={12} className={classes.dashboardAlign}>
                            <Grid container item xs={12} hidden={markupLoaded ? false : statusNameXmlHiddenMarkup}>
                               <Grid item xs={7} style={{ textAlign: 'right', paddingTop: '15px', paddingright: '10px' }}>
                                <label style={{marginLeft: '60px'}}>{nameXMLMarkup}</label>
                               </Grid>
                               <Grid item xs={5} style={{ textAlign: 'left' }}>
                                <IconButton aria-label="delete" className={classes.ButtonDelete} disabled={markupLoaded ? true : disabledMarkupButton} onClick={ClearMarkupXML}>
                                   <DeleteIcon />
                                </IconButton>
                               </Grid>
                            </Grid>
                            </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridMarkup}>
                            <Grid item xs={12} className={classes.dashboardAlign}>
                            <br />
                            <Grid container item xs={12}>
                               <Grid item xs={8}>
                                <div className="form-group files" style={{textAlign: 'left'}}>
                                   <label style={{marginLeft: '60px'}}>Subir PDF de comisión&nbsp;&nbsp;</label>
                                   <Input type="file" name="file" disabled={markupLoaded ? true : disabledMarkupButton} className="filePDFMarkup" onChange={onChangeHandlerPDFMarkup} />
                                </div>
                              </Grid>
                            </Grid>
                            </Grid>
                            </Grid>

                            <Grid container item xs={12} hidden={statusGridMarkup} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12} hidden={markupLoaded ? false : statusNamePdfHiddenMarkup}>
                                        <Grid item xs={7} style={{ textAlign: 'right', paddingTop: '15px', paddingright: '10px' }}>
                                            <label>{namePDFMarkup}</label>
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <IconButton aria-label="delete" className={classes.ButtonDelete} disabled={markupLoaded ? true : disabledMarkupButton} onClick={ClearMarkupPDF}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} hidden={statusGridMarkup} style={{ textAlign: 'center', paddingTop: '10px' }}>
                                <Grid container item xs={12}>
                                    <Grid item xs={8}></Grid>
                                    <Grid item xs={4}>
                                        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                                            <Button type="button" className={classes.ButtonSave} variant="outlined" disabled={markupLoaded ? true : disabledMarkupButton} onClick={SendMarkupFile}>Guardar</Button>
                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {
                                props.listRejectedInvoices && (
                                    <Grid item xs={12} hidden={statusGridRejectedInvoice} style={{ paddingTop: '15px' }}>
                                        <DataTable
                                            columns={getRejectedInvoiceTableColumns('Maintenance', { DeleteRejectedInvoice })}
                                            data={props.listRejectedInvoices}
                                            defaultSortField=""
                                            noHeader={true}
                                            dense
                                            highlightOnHover
                                            pointerOnHover
                                        />
                                    </Grid>
                                )
                            }

                            <br />
                            <br />
                            <Grid container item xs={12} hidden={statusGridHistory} >
                                <Grid item xs={12} >
                                    <DataTable
                                        columns={getInvoiceHitoricalTableColumns('Maintenance')}
                                        data={props.listHistory}
                                        defaultSortField=""
                                        noHeader={true}
                                        dense
                                        highlightOnHover
                                        pointerOnHover
                                        pagination
                                        paginationComponentOptions={paginationOptions}
                                    />
                                </Grid>
                            </Grid>
                            <br />
                            <br />
                        </Container>
                    </Grid>
                </Grid>
            </Container>

            <ToastContainer />
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listHistory: state.MaintenanceReducer.historyList,
    orderDetail: state.MaintenanceReducer.orderDetail,
    listRejectedInvoices: state.MaintenanceReducer.listRejectedInvoices,
    result: state.MaintenanceReducer.result,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(maintenanceActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(MaintenanceStylesInvoice)(MaintenanceUploadInvoice))